import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    createGroupEmail: {
        method: 'POST',
        url: `${BASE_PATH_API}/communication/groupEmails`
    },
    getRecipients: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/groupEmails/:recipientType/recipients`,
        cache: true,
        isArray: true
    },
    getRecipientsViaPost: {
        method: 'POST',
        url: `${BASE_PATH_API}/communication/groupEmails/:recipientType/recipients`,
        cache: true,
        isArray: true
    },
    getGroupEmailFromOptions: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/groupEmails/fromOptions`,
        isArray: true
    },
    getGroupEmailAttachments: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/groupEmails/attachments`,
        cache: true,
        isArray: true
    },
    getGroupEmailAttachment: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/groupEmails/attachments/:id`
    },
    getDistributionList: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/groupEmails/distributionList`,
        isArray: true
    },
    getDistributionListDetails: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/groupEmails/distributionList/:id`,
        isArray: true
    },
    createDistributionList: {
        method: 'POST',
        url: `${BASE_PATH_API}/communication/groupEmails/distributionList/`
    },
    deleteDistritbutionListById: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/communication/groupEmails/distributionList/:id`
    },
    getMailingRecipients: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/groupEmails/mailings/:id/recipients`
    },
    getMailingRecipientsByLeases: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/groupEmails/leases/recipients`,
        isArray: true
    },
    getMailingCriteriaForEmail: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/groupEmails/mailings/:id/criteria`
    },
    getRecipientDetails: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/groupEmails/recipients/:id`
    },
    getUsersFromBouncedRecipients: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/groupEmails/:id/bouncedRecipients`,
    },
    getRecipientsDetails: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/groupEmails/recipients?id?recipientType`
    },
    getEmailSentCount: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/groupEmails/emailSentCount`
    },
    getTrialEmailLimit: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/groupEmails/trialEmailLimit`
    },

    getAttachmentsByThreadId: {
        method: 'GET',
        url: `${BASE_PATH_API}/emailThreads/:emailThreadId/attachments`,
        params: { emailThreadId: '@emailThreadId' },
    }
};

export function GroupEmailApi() {
    return createActions(actions);
}
